import { useRouter } from 'next/router';

import { LinkButton } from '../../../Toolkit/Button/LinkButton';
import { Text } from '../../../ToolkitV2/Text/Text';

import { Spacer } from '../../../../helpers/genericStyles';

import * as Styled from './LoadError.styled';

const LoadError = () => {
  const { reload } = useRouter();

  return (
    <Styled.Container>
      <Styled.ErrorIcon />
      <Spacer marginBottom="M24" />
      <Text forwardedAs="h1" size="H24" weight="bold" color="GREY_DARKER">
        Something went wrong
      </Text>
      <Spacer marginBottom="M16" />
      <Text size="M16" weight="semibold">
        Try{' '}
        <LinkButton inline onClick={reload}>
          reloading the page
        </LinkButton>{' '}
        or come back later.
      </Text>
    </Styled.Container>
  );
};

export { LoadError };
